export const VILNIUS_CIVIC_SQUARE_MANIFEST_URL =
  "/assets/civic-squares/manifest.json";

/**
 * Civic-square surfaces follow the shared terrain within centimetres so the
 * avatar stays grounded on the authoritative terrain collider. These render-
 * only depth biases keep the stacked paving layers stable at flight-camera
 * distances without lifting the visual geometry away from that collider.
 */
export const VILNIUS_CIVIC_SQUARE_IDS: ReadonlySet<string> = new Set([
  "vilnius-town-hall-square",
  "vilnius-cathedral-square",
  "vilnius-lukiskes-square",
  "vilnius-simono-daukanto-square",
  "vilnius-vinco-kudirkos-square",
  "vilnius-reformatai-garden",
  "vilnius-vingriai-springs-square",
  "vilnius-konstantino-sirvydo-square",
  "vilnius-tibet-square",
  "vilnius-odminiu-square",
  "vilnius-moniuska-square",
  "vilnius-konstitucijos-artery-forecourt",
  "vilnius-konstitucijos-municipality-forecourt",
  "vilnius-konstitucijos-europa-square",
]);

/**
 * These OSM hardscape polygons are reconstructed by the authored civic-square
 * assets. Rendering both copies produces coincident surfaces and lets the
 * generic city material mask the source-specific paving at distance.
 */
export const VILNIUS_CIVIC_SQUARE_REPLACED_HARDSCAPE_IDS:
  ReadonlySet<string> = new Set([
    "osm:way:54055201",
    "osm:way:24570283",
    "osm:way:1077046662",
    "osm:way:232438899",
    "osm:way:1485530707",
  ]);

export const VILNIUS_CIVIC_SQUARE_SURFACE_MATERIAL_NAMES:
  ReadonlySet<string> = new Set([
    "town_base",
    "town_stone_a",
    "town_stone_b",
    "town_band",
    "cathedral_paving",
    "cathedral_marker",
    "daukanto_paving",
    "daukanto_axis",
    "kudirka_stone",
    "kudirka_memorial",
    "garden_paving",
    "garden_gravel",
    "garden_step",
    "water",
    "water_edge",
    "tibet_base",
    "tibet_path",
    "tibet_marker",
    "memorial_dark",
    "bench_wood",
    "metal_art",
    "path_granite",
    "path_granite_alt",
    "path_gravel",
    "fountain_stone",
    "fountain_nozzle",
    "brass",
    "compass_red",
    "compass_dark",
    "new_centre_paving",
    "new_centre_paving_alt",
    "new_centre_green",
  ]);

export const VILNIUS_CIVIC_SQUARE_SURFACE_POLYGON_OFFSET_FACTOR = -3;
export const VILNIUS_CIVIC_SQUARE_SURFACE_POLYGON_OFFSET_UNITS_BY_MATERIAL:
  Readonly<Record<string, number>> = Object.freeze({
    town_base: -1,
    town_stone_a: -2,
    town_stone_b: -2,
    town_band: -5,
    cathedral_paving: -1,
    cathedral_marker: -3,
    daukanto_paving: -1,
    daukanto_axis: -3,
    kudirka_stone: -1,
    kudirka_memorial: -3,
    garden_paving: -2,
    garden_gravel: -2,
    garden_step: -3,
    water: -4,
    water_edge: -3,
    tibet_base: -1,
    tibet_path: -3,
    tibet_marker: -4,
    memorial_dark: -3,
    bench_wood: -2,
    metal_art: -3,
    path_granite: -2,
    path_granite_alt: -2,
    path_gravel: -2,
    fountain_stone: -3,
    fountain_nozzle: -4,
    brass: -4,
    compass_red: -4,
    compass_dark: -4,
    new_centre_paving: -2,
    new_centre_paving_alt: -3,
    new_centre_green: -4,
  });
